export const SET_RACE_ID = 'SET_RACE_ID';
export const SET_RACE_TOKEN = 'SET_RACE_TOKEN';
export const SET_CONNECTION_STATUS = 'SET_CONNNECTION_STATUS';
export const SET_TIME_SYNC = 'SET_TIME_SYNC';
export const CONNECTION_STATUS = {
  CONNECTED: 'CONNECTED',
  WAITING: 'WAITING',
  FAILED: 'FAILED',
};
